import moment from 'moment'
import React, { useEffect, useState, useMemo } from 'react'
import { removeDevices } from 'src/api/userInfo'
import {  Device_Icon, Error_Icon, MsSql_Icon, Offline_Icon, Warning_Icon } from '../icons'
import { Icon_Library } from 'src/utils/widgetLibrary/IconTemplates/Icon_library'
import Online_Icon from '../../widgets/widget_layouts/icons/DeviceListControl/Online_Icon'
import { DeleteConfirmationAlert } from '../../ui/alert-dialog/delete-server-confirmation'
import { deviceStatusName } from 'src/shared/constants/deviceStatus'


export const DeviceTableRow = ({ device, showData, openEditDevice, removeDevice,getLocationInfo }) => (
    <tr className="relative break-words hover:bg-vekin-green-50" key={device?.id}>
      <td className="text-sm capitalize text-tertiary">
        <label className='flex flex-row items-center gap-2'>
          {/* <input type="checkbox" className="w-6 h-6 accent-vekin" /> */}
          {moment(device?.datetime_updated)?.format('lll')}
        </label>
      </td>
      <td className="text-sm font-bold text-vekin w-[20rem]">
        {device?.device_type !== "{}" ? device?.device_type : "--"}
      </td>
      <td className="text-sm text-black w-[20rem]">{device?.name}</td>
      <td className="relative text-sm text-tertiary group min-w-[20rem] max-w-[20rem] xl:max-w-[25rem] 3xl:min-w-[40rem] 3xl:max-w-[40rem] truncate ... hover:whitespace-normal">
      {getLocationInfo(device?.place)}
      </td>




      <td className="text-sm text-tertiary w-[10rem]">
        <div className="flex items-center gap-2 capitalize">
          <div className='w-5 h-5 rounded-full' style={{backgroundColor: deviceStatusName[device?.status]?.color}}></div>
          {deviceStatusName[device?.status]?.name}
          {/* {device?.status === 1 ? (
            <>
              <Online_Icon /> Online
            </>) : device?.status === 2 ? (
            <>
              <Offline_Icon /> Offline
            </>) : device?.status === 3 ? (
            <>
              <Warning_Icon /> Warning
            </>) : (
            <>
              <Error_Icon /> Error
            </>)
          } */}
        </div>
      </td>
      {showData && (
        <td className="flex justify-center items-center space-x-10 text-center text-tertiary w-[10rem] h-full">
         <button type='button' onClick={() => openEditDevice(device)}><i className="text-lg cursor-pointer ri-edit-2-fill text-vekin"></i></button>
          <DeleteConfirmationAlert item={device} category="device" onContinue={() => removeDevice(device)} />
        </td>
      )}
    </tr>
  );
  